import { render, staticRenderFns } from "./getMoneyRemind.vue?vue&type=template&id=afa55444&scoped=true&"
import script from "./getMoneyRemind.vue?vue&type=script&lang=js&"
export * from "./getMoneyRemind.vue?vue&type=script&lang=js&"
import style0 from "./getMoneyRemind.vue?vue&type=style&index=0&id=afa55444&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afa55444",
  null
  
)

export default component.exports